<template>
  <div>
    <v-row v-for="(item, i) in value.items" :key="i"
           :style="{'background' : value.sectionColor.backGround, 'color' : value.sectionColor.text}"
           class="mt-4 mb-12 justify-center" no-gutters>
      <v-col cols="12" lg="9" md="10" sm="11">
        <v-row class="pa-3" no-gutters>
          <v-col cols="12">
            <p class="mr-5 mb-2">{{ item.name }}</p>
          </v-col>

          <v-col v-for="(product, i) in childProducts(item)" :key="i" cols="12">
            <ads-card :value="product"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AdsCard from "@/view/components/Product/adsCard";

export default {
  name: "AdsComponents",

  components: {AdsCard},

  props: {
    value: Object
  },

  methods: {
    childProducts(category) {
      function getChildren(category) {
        let products = []

        if (!!category.children?.length) {
          category.children.forEach(item => {
            products = [...products, ...getChildren(item) || []].flat()
          })
        }

        return [...category.products, ...products]
      }

      return getChildren(category)
    }
  }
}
</script>

<style scoped>

</style>